/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {CaptureVideoComponent as ɵa} from './lib/capture-video/capture-video.component';